import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { useRemoveOrderFromSellarDistributionPallet } from "./hooks/useRemoveOrderToSellarDistributionPallet";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { Alert } from "../../../../components/alert/Alert";

export function AdminRemoveOrderFromPallet({
  active,
  orderId,
  onDismiss,
}: {
  active: boolean;
  orderId: number;
  onDismiss: () => void;
}): ReactElement {
  const removeOrderFromSupplierPalletShipmentMutation =
    useRemoveOrderFromSellarDistributionPallet(orderId);

  const onConfirm = () => {
    removeOrderFromSupplierPalletShipmentMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title="Remove order from pallet"
      />
      <DialogContent>
        {removeOrderFromSupplierPalletShipmentMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(
                removeOrderFromSupplierPalletShipmentMutation.error,
              )?.response?.data.message ?? "An unknown error occurred"
            }
          />
        )}

        <div>
          Please confirm you wish to remove the order from associated pallet
        </div>
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm}>Confirm</Button>
      </DialogCTA>
    </Dialog>
  );
}
